export default "__VITE_ASSET__Csn4KL34__"